import { BrowserRouter } from 'react-router-dom';
import { Router } from '../router';
import { SocketProvider } from '../contexts/SocketContext';

function App() {
  return (
    <SocketProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </SocketProvider>
  );
}

export default App;
